import { useOutletContext } from 'react-router-dom'
import ScriptEditorContent from './ScriptEditorContent'
import BeatBoardContent from './BeatBoardContent'
import OutlineContent from './OutlineContent'

interface DraftContext {
    currentTab: string
    selectedDraftId: string
    project: {
        id: string
        name: string
        description: string | null
        status: string
    } | null
}

export default function DraftEditorPage() {
    const { currentTab, selectedDraftId } = useOutletContext<DraftContext>()

    // Don't render content components until we have a valid draft ID
    if (!selectedDraftId) {
        return (
            <div className="flex items-center justify-center h-full">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
            </div>
        )
    }

    // Render content based on current tab
    switch (currentTab) {
        case 'script':
            return <ScriptEditorContent key={selectedDraftId} draftId={selectedDraftId} />
        case 'beats':
            return <BeatBoardContent key={selectedDraftId} draftId={selectedDraftId} />
        case 'outline':
            return <OutlineContent key={selectedDraftId} draftId={selectedDraftId} />
        default:
            return <ScriptEditorContent key={selectedDraftId} draftId={selectedDraftId} />
    }
}
